import React from "react";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const FirebaseDataModal = ({ showModal, toggleModal, firebaseData }) => {
  function calculateProgressWidth() {
    const points = firebaseData?.points || 0;
    if (points <= 50) {
      return (points / 50) * 100;
    } else if (points <= 200) {
      return ((points - 50) / 150) * 100;
    } else if (points <= 500) {
      return ((points - 200) / 300) * 100;
    } else if (points <= 1000) {
      return ((points - 500) / 500) * 100;
    } else if (points <= 2000) {
      return ((points - 1000) / 1000) * 100;
    } else {
      return 100;
    }
  }

  function calculateProgressWidth2() {
    const points = firebaseData?.pointsTeam || 0;
    if (points <= 50) {
      return (points / 50) * 100;
    } else if (points <= 200) {
      return ((points - 50) / 150) * 100;
    } else if (points <= 500) {
      return ((points - 200) / 300) * 100;
    } else if (points <= 1000) {
      return ((points - 500) / 500) * 100;
    } else if (points <= 2000) {
      return ((points - 1000) / 1000) * 100;
    } else {
      return 100;
    }
  }

  const closeIcon = (
    <Button type="button" buttonClass="btn-close modalClose2">
      <CloseIcon onClick={toggleModal} />
    </Button>
  );

  return (
    <Modal open={showModal} onClose={toggleModal} center closeIcon={closeIcon}>
      <h1 className="textAlign">
        <strong className="fontSize">WOW!</strong>
      </h1>
      <p style={{ fontSize: "16px" }}>
        You've earned additional points, bringing you closer to reaching the
        next badge level
      </p>

      <div className="progress-title">
        <h5>Your personal progress</h5>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div class="progress-bar-inner">
            <div
              class="progress-bar-fill"
              style={{ width: `${calculateProgressWidth()}%` }}
            >
              <span className="progress-bar-text">{firebaseData?.points}</span>
            </div>
          </div>
        </div>
        <span class="progress-label left-label">
          {firebaseData?.minPoints} min
        </span>
        <span class="progress-label right-label">
          {firebaseData?.maxPoints} max
        </span>
      </div>
      <div className="progress-title">
        <h5>Your team progress</h5>
      </div>
      <div class="progress-bar-container" style={{ marginBottom: "57px" }}>
        <div class="progress-bar">
          <div class="progress-bar-inner">
            <div
              class="progress-bar-fill"
              style={{ width: `${calculateProgressWidth2()}%` }}
            >
              <span className="progress-bar-text">
                {firebaseData?.pointsTeam}
              </span>
            </div>
          </div>
        </div>
        <span class="progress-label left-label">
          {firebaseData?.minPointsTeam} min
        </span>
        <span class="progress-label right-label">
          {firebaseData?.maxPointsTeam} max
        </span>
      </div>
    </Modal>
  );
};

export default FirebaseDataModal;
